import { Col, Select } from "antd";

import { ISelectField } from "./ISelectField";

import { sizes } from "../../../Assets/Enums";

const SelectField = ({
	className,
	value,
	fieldName,
	disabled = false,
	size,
	index = 0,
	options,
	translations,
	errors,
	handleSelect,
}: ISelectField) => (
	<Col xs={24} md={sizes[size]} lg={sizes[size]}  className="titles">
		<label className="required"> {translations[fieldName]} </label>
		<Select
			className="input-field"
			value={value}
			disabled={disabled}
			onChange={handleSelect(fieldName, index)}
			showSearch
			optionFilterProp="label"
			status={errors[index][fieldName] ? 'error' : ''}
			placeholder={translations.seleccioneOpcion}
			options={options}
		/>
		<span className={`error ${errors[index][fieldName] ? 'show' : null}`}>{translations.seleccioneOpcion}</span>
	</Col>
);

export default SelectField;